import { computed } from 'vue'

import { DATE_RANGE_MAX_AGE_MS, useDateRangeStore } from './dateRangeStore'
import type { DateRangeBounds, DateRangeSelection } from './types'

export function useDateRange(
  id: string,
  options: { linkedIds?: readonly string[]; maxAgeMs?: number } = {},
) {
  const store = useDateRangeStore()
  const maxAgeMs = options.maxAgeMs ?? DATE_RANGE_MAX_AGE_MS
  if (store.isStale(id, maxAgeMs)) store.clear(id)

  return {
    selection: computed(() => store.selectionFor(id)),
    bounds: computed(() => store.boundsFor(id)),
    isStale: computed(() => store.isStale(id, maxAgeMs)),
    setSelection(selection: DateRangeSelection, link = false): void {
      store.setSelection(id, selection, link ? options.linkedIds : [])
    },
    setBounds(bounds: DateRangeBounds): void {
      store.setBounds(id, bounds)
    },
    reset(): void {
      store.clear(id)
    },
  }
}
